import { render, staticRenderFns } from "./CollectionActionSchedule.vue?vue&type=template&id=18a0da96&scoped=true&"
import script from "./CollectionActionSchedule.vue?vue&type=script&lang=ts&"
export * from "./CollectionActionSchedule.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionActionSchedule.vue?vue&type=style&index=0&id=18a0da96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a0da96",
  null
  
)

export default component.exports